import { URL_REPLACEMENT } from '$const';
import { ROUTE_CHANGELOG, ROUTE_EDIT_NAVIGATION, ROUTE_EDIT_USERGROUPS } from '$routes';
import { PopupMenu, PopupMenuItemShape } from '~components/generic/popup-menu/PopupMenu';
import { DocumentUpdateIcon, MenuIcon, TeamIcon, UserIcon } from '~components/icons';
import { Logout } from '~components/icons/Logout';
import useAppSelector from '~hooks/useAppSelector';
import { useNavigateToPage } from '~hooks/useNavigateToPage';
import usePermissions from '~hooks/usePermissions';
import { useAppLogin } from '~services/env';
import { NavigationStyle } from '~store/enums/navigation';
import { selectContext } from '~store/selectors';
import replaceUrl from '~utils/replaceUrl';

export type SettingsMenuProps = {
  onClose: () => void;
  pageX: number;
  pageY: number;
  userId: number;
  position?: 'TOP_RIGHT' | 'BOTTOM_LEFT';
  navigationStyle?: string;
};

export const SettingsMenu = (props: SettingsMenuProps) => {
  const { hasManageMenuElementsPermission, hasManageUsergroupsPermission, hasViewChangelogPermission } =
    usePermissions();
  const context = useAppSelector(selectContext);

  const navigateToPage = useNavigateToPage();

  const items: PopupMenuItemShape[] = [
    {
      id: 'editUserProfile',
      label: 'btnEditUserProfile',
      onClick: () => {
        if (props.userId) {
          window.location.href = replaceUrl(`${URL_REPLACEMENT.BACKEND_URL}/user/${props.userId}/edit`);
        }
      },
      disabled: !props.userId,
      icon: <UserIcon />,
    },
  ];

  if (hasManageMenuElementsPermission) {
    items.push({
      id: 'editNavigation',
      label: 'btnEditNavigation',
      onClick: () => navigateToPage(ROUTE_EDIT_NAVIGATION),
      icon: <MenuIcon />,
    });
  }

  if (hasManageUsergroupsPermission) {
    items.push({
      id: 'editUsergroups',
      label: 'btnEditUsergroups',
      onClick: () => navigateToPage(ROUTE_EDIT_USERGROUPS),
      icon: <TeamIcon />,
    });
  }

  if (hasViewChangelogPermission) {
    items.push({
      id: 'changelog',
      label: 'btnChangelog',
      onClick: () => navigateToPage(ROUTE_CHANGELOG),
      icon: <DocumentUpdateIcon />,
    });
  }

  if (!context && !useAppLogin && !!props.userId && props.navigationStyle === NavigationStyle.HORIZONTAL) {
    items.push({
      id: 'Logout',
      label: 'btnLabelLogout',
      onClick: () => {
        window.location.href = replaceUrl(`${URL_REPLACEMENT.BACKEND_URL}/user/logout`);
      },
      icon: <Logout />,
    });
  }

  return <PopupMenu onClose={props.onClose} items={items} x={props.pageX} y={props.pageY} position={props.position} />;
};
